import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const respondToDispute = ({
  disputeId,
  action,
  evidence
}: {
  disputeId: string,
  action: 'accept' | 'submit_evidence',
  evidence?: {
    message?: string,
    files: File[]
  }
}) => {

  const formData = new FormData();

  formData.append("action", action);

  if (action === 'submit_evidence') {
    evidence?.message && formData.append("message", evidence.message);

    evidence?.files.forEach((file) => {
      formData.append("files", file);
    });
  };

  const headers = { 'Content-Type': 'multipart/form-data' };

  return axiosPrivate.post(`/dashboard/api/v1/disputes/${disputeId}/respond`, formData, { headers });
};